import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BriefcaseBusiness, GraduationCap, UsersRound } from 'lucide-react';
import { IMG } from '../mock';

// Les deux cadrages du hero sont servis depuis /public/assets/ :
// paysage sur ordinateur, portrait sur mobile.

const doors = [
  ['MCE Academy', 'Développer les compétences par des formations actives, pratiques et certifiantes.', 'Formation · Pratique · Mise en situation · Certificat', '/talents-rh/academy', GraduationCap, '/assets/Académie_MCE1.png'],
  ['Recrutement & sourcing', 'Identifier, évaluer et recommander les profils adaptés aux besoins des entreprises et organisations.', 'Besoin · Sourcing · Entretiens · Intégration', '/talents-rh/recrutement', BriefcaseBusiness, '/assets/recrutement.jpg'],
  ['Accompagnement RH', 'Structurer les équipes, les pratiques managériales et le développement des compétences.', 'Organisation · Management · Performance · Coaching', '/talents-rh/accompagnement-rh', UsersRound, '/assets/accompagnementRH.png'],
];

export default function TalentsRH() {
  return (
    <main className="pt-[72px] rh-hub">

      {/* ========================================================= */}
      {/* ============= HERO — VERSION DESKTOP (md+) ============== */}
      {/* ========================================================= */}
      <section className="hidden md:block rh-hub-hero rh-hub-hero-photo">
        <picture className="hero-responsive-media">
          <img src="/assets/HERO-TALENT-RH.png" alt="Entretien professionnel entre collaborateurs" />
        </picture>
        <div />
        <div className="max-w-[1200px] mx-auto px-6">
          <h1>
            Révélez le potentiel<br />
            de vos <em>équipes</em> et accélérez<br />
            leur développement.
          </h1>
          <p>
            Recrutement, sourcing, formations pratiques et accompagnement RH : <br />
            MCE développe et connecte les talents dont votre organisation a besoin.
          </p>
          <a href="#portes">
            Développer vos talents <ArrowRight />
          </a>
        </div>
      </section>

      {/* ========================================================= */}
      {/* ============= HERO — VERSION MOBILE (<md) =============== */}
      {/* ========================================================= */}
      <section className="md:hidden rh-hub-hero-mobile">
        <picture className="rh-hub-mobile-media">
          <img
            src="/assets/accompagnementRH.png"
            alt="Poignée de main lors d'un entretien professionnel"
          />
        </picture>

        {/* Sur mobile, une composition éditoriale distincte présente clairement l'offre avant le visuel. */}
        <div className="rh-hub-mobile-copy">
          <h1>
            Trouver le bon profil, avec une méthode claire.
          </h1>
          <p>
            MCE accompagne les PME, entreprises, ONG et organisations dans la recherche,
            l’évaluation et l’intégration de candidats adaptés au poste et à la réalité de la structure.
          </p>
          <Link to="/talents-rh/recrutement">
            Confier vos recrutements à MCE
            <ArrowRight />
          </Link>
        </div>
      </section>

      {/* ========================================================= */}
      {/* ===================== PORTES / PROGRAMMES =============== */}
      {/* ========================================================= */}
      <section id="portes" className="rh-doors rh-programs">
        <div className="max-w-[1200px] mx-auto px-6">
          <header>
            <h2>Trois expertises pour faire progresser les talents et les organisations</h2>
          </header>

          <div>
            {doors.map(([t, d, tags, to, Icon, img], index) => (
              <article key={t} className={`rh-program-${index + 1}`}>
                <div className="rh-door-image">
                  <img src={img} alt={t} />
                </div>
                <div>
                  <Icon />
                  <h3>{t}</h3>
                  <p>{d}</p>
                  <small>{tags}</small>
                  <Link className="rh-program-cta" to={to}>
                    <span>Découvrir ce parcours</span>
                    <ArrowRight />
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ========================================================= */}
      {/* ===================== FLOW ============================== */}
      {/* ========================================================= */}
      <section className="rh-hub-flow">
        <div className="max-w-[1050px] mx-auto px-6">
          <h2>
            Les bonnes personnes, les bonnes compétences et une organisation qui les fait progresser.
          </h2>
          <div>
            <b>RECRUTER</b><i /><b>FORMER</b><i /><b>STRUCTURER</b>
          </div>
        </div>
      </section>
    </main>
  );
}